export enum AuthState {
  Undecided = 0, //The application did not yet check
  OkWithOnlineAuthentication, //The application was able to authenticate online
  OkButOffline, //The application was not able to authenticate online but should working fine with offline mode
  Failed, //Authentication failed for whatever reason
  LocalStorageDeletionNecessary, //Authentication successful. However: A different user logged in than the one that owns the data saved in the local storage --> Deletion necessary
  RedirectToLoginNecessary, //
  SessionExpired, // Auth0 explicitly rejected the session (login_required, consent_required, interaction_required)
}
